import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function PrivacyNoticeCard() {
  const [n, setN] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/privacy/notice").then((r) => setN(r.data)); }, []);
  if (!n) return null;
  const save = async () => {
    setBusy(true);
    try {
      setN((await api.put("/admin/privacy/notice", { text: n.text })).data);
      toast.success("Informativa salvata");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="rounded-2xl border bg-white p-5 sm:p-6" data-testid="privacy-notice-card">
      <h2 className="mb-1 font-display text-lg font-semibold">Informativa dipendenti (art. 4 Statuto dei Lavoratori)</h2>
      <p className="mb-3 text-xs text-slate-500">Completa le parti tra [ ] e falla verificare dal tuo consulente del lavoro. Si invia dalla pagina Utenti con "Invia informativa". Se modifichi il testo, i dipendenti dovranno confermarlo di nuovo.</p>
      <Textarea rows={14} value={n.text} onChange={(e) => setN((p) => ({ ...p, text: e.target.value }))} className="font-mono text-xs" data-testid="privacy-notice-textarea" />
      <Button onClick={save} disabled={busy} className="mt-3 rounded-full" data-testid="privacy-notice-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Salva informativa</Button>
    </section>
  );
}
